import { ControlledTextInput } from 'wisestep-base';

import WsAccordion from './WsAccordion';

interface TextInputFilterProps {
  name: string;
  placeholder: string;
  title: string;
  disabled?: boolean;
  infoText?: string;
  startIcon?: React.ReactElement;
}

const TextInputFilter = ({
  name,
  placeholder,
  title,
  disabled,
  infoText,
  startIcon,
}: TextInputFilterProps) => {
  return (
    <WsAccordion
      title={title}
      disabled={disabled}
      infoText={infoText}
      {...(startIcon && { startIcon: startIcon })}
    >
      <ControlledTextInput
        name={name}
        fullWidth
        id={`${name}-field`}
        placeholder={placeholder}
        variant="outlined"
        size="small"
      />
    </WsAccordion>
  );
};
export default TextInputFilter;
